import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FooterItems } from './o-footer.model';
import { Router, NavigationStart } from '@angular/router';

@Component({
    selector: 'o-footer',
    templateUrl: './o-footer.component.html',
    styleUrls: ['./o-footer.component.scss'],
})
export class FooterComponent implements OnInit {
    @Input() footerItems: FooterItems[] = [];
    @Input() copyItemsLeft: Array<any> = [];
    @Input() copyItemsRight: Array<any> = [];
    @Input() colClass?: string;
    @Input() title!: string;
    @Input() containerClass?: string;
    @Input() hideInRoutes: string[] = [];
    showComponent: boolean = true;
    constructor(private translateService: TranslateService, private router: Router) {}

    ngOnInit(): void {
        this.router.events.subscribe((val) => {
            if (val instanceof NavigationStart) {
                this.showComponent = !this.hideInRoutes?.includes(val.url);
            }
        });
        this.showComponent = !this.hideInRoutes?.includes(this.router.url);
    }

    get colClassCss(): String {
        return this.colClass ?? '';
    }

    getbtnLabel(key: string): string {
        return this.translateService.instant(key);
    }
}
